"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConstructionEstimates = void 0;
const anchor_1 = require("@project-serum/anchor");
const __1 = require("..");
const tokens_1 = require("../utils/tokens");
const updateEstimatedOutsForAction = (currEstimatesOut, actionOutEstimate, action) => {
    const orderIdx = actionOutEstimate.map((a) => {
        return action.tokenMintOuts.findIndex((mint) => mint.toBase58() === a.mint.toBase58());
    });
    return orderIdx.map((outIdx, i) => {
        if (outIdx === -1) {
            throw `Expected the action's out estimate to have an estimate for all mints which the action will return`;
        }
        return currEstimatesOut[outIdx].add(new anchor_1.BN(actionOutEstimate[i].amount));
    });
};
const updateEstimatedIns = (currEstimatesIn, action, actionOutEstimate, inMintsPerAction) => {
    if (action.nextNodes.length === 0)
        return { newIn: currEstimatesIn };
    if (action.nextNodes.length !== actionOutEstimate.length) {
        throw `Expected the number of estimates out to equal or be greater than the number of next mints if there is a continuation from the action`;
    }
    // Clone the arrays
    const newEstimatesIn = [...currEstimatesIn.map((est) => [...est])];
    actionOutEstimate.forEach((estimate, i) => {
        const splits = action.nextNodes[i].map((nextNode) => nextNode.fraction);
        // You cannot simply use the next input mint idx of next node here as
        // there is no guarantee on the ordering of estimateOuts
        const nextMintIdx = action.nextNodes[i].map((nextNode, i) => {
            const nextMintIdx = inMintsPerAction[nextNode.actionIdx].findIndex((m) => m.mint.toBase58() === estimate.mint.toBase58());
            if (nextMintIdx === -1)
                throw `Expected the action's out estimate to have an estimate for all mints which feed into next actions`;
            return nextMintIdx;
        });
        const nextActionIdxs = action.nextNodes[i].map((nextNode) => nextNode.actionIdx);
        const nextEstimates = (0, tokens_1.splitTokensByFractions)(new anchor_1.BN(estimate.amount), splits);
        nextActionIdxs.forEach((actionIdx, i) => {
            const nextMintIdxForNextAction = nextMintIdx[i];
            newEstimatesIn[actionIdx][nextMintIdxForNextAction] = newEstimatesIn[actionIdx][nextMintIdxForNextAction].add(nextEstimates[i]);
        });
    });
    return { newIn: newEstimatesIn };
};
const getInitEstimatedAmountsIn = (numbActions, construction, initActionIdxs, initMints, vertexInfos, inMintsPerAction) => {
    // The outer index corresponds to the action index, the inner to the different values on
    // the input mints
    let estimatedAmountsOnAction = Array(numbActions)
        .fill(0)
        .map((_, i) => Array(vertexInfos[i].numberInputMints).fill(new anchor_1.BN(0)));
    const amounts = Object.values(construction.source.mints);
    console.log(amounts);
    const initialSplitVals = amounts.map((amountForToken) => (0, tokens_1.splitTokensByFractions)(new anchor_1.BN(amountForToken), Object.values(construction.source.nextActions)));
    initialSplitVals.forEach((splitValByToken, mintIdx) => {
        const mint = initMints[mintIdx];
        initActionIdxs.forEach((actionIdx, i) => {
            const mintIdxForAction = inMintsPerAction[actionIdx].findIndex((m) => m.mint.toBase58() === mint.toBase58());
            if (mintIdxForAction === -1) {
                throw `Unexpected error: expected to find the initial mint indices in the init mints for an action`;
            }
            estimatedAmountsOnAction[actionIdx][mintIdxForAction] =
                estimatedAmountsOnAction[actionIdx][mintIdxForAction].add(splitValByToken[i]);
        });
    });
    return estimatedAmountsOnAction;
};
const getInitEstimatedAmountsOut = (isolatedActions) => {
    let estimatedAmountsOnAction = Array(isolatedActions.length)
        .fill(0)
        .map((_, i) => Array(isolatedActions[i].tokenMintOuts.length).fill(new anchor_1.BN(0)));
    return estimatedAmountsOnAction;
};
const getConstructionEstimates = (order, actionsIsolated, construction, initActionIdxs, initMints, actionVertexInfo, estimateFns, inMintsPerAction) => __awaiter(void 0, void 0, void 0, function* () {
    let estimatedAmountOuts = getInitEstimatedAmountsOut(actionsIsolated);
    let estimatedAmountIn = getInitEstimatedAmountsIn(actionsIsolated.length, construction, initActionIdxs, initMints, actionVertexInfo, inMintsPerAction);
    const estimateArrInToMintWithAmount = (estimates, actionIdx) => {
        return estimates.map((e, i) => {
            return {
                mint: inMintsPerAction[actionIdx][i].mint,
                amount: e,
            };
        });
    };
    const estimateArrOutToMintWithAmount = (estimates, actionIdx) => {
        return estimates.map((e, i) => {
            return {
                mint: actionsIsolated[actionIdx].tokenMintOuts[i],
                amount: e,
            };
        });
    };
    for (let o = 0; o < order.length; o++) {
        const orderGroup = order[o];
        for (let q = 0; q < orderGroup.length; q++) {
            const actionIdx = orderGroup[q];
            const action = actionsIsolated[actionIdx];
            try {
                const out = yield estimateFns[actionIdx](estimateArrInToMintWithAmount(estimatedAmountIn[actionIdx], actionIdx));
                const { newIn } = updateEstimatedIns(estimatedAmountIn, actionVertexInfo[actionIdx], out, inMintsPerAction);
                estimatedAmountIn = newIn;
                estimatedAmountOuts[actionIdx] = updateEstimatedOutsForAction(estimatedAmountOuts[actionIdx], out, actionsIsolated[actionIdx]);
            }
            catch (e) {
                console.error(e);
                throw __1.errors.newActionBuilderError(action.nonSpecificAction.actionTypeUID, action.actionName, actionIdx, e);
            }
        }
    }
    return {
        estimateOuts: estimatedAmountOuts.map((est, i) => estimateArrOutToMintWithAmount(est, i)),
        estimateIns: estimatedAmountIn.map((est, i) => estimateArrInToMintWithAmount(est, i)),
    };
});
exports.getConstructionEstimates = getConstructionEstimates;
